import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: [],
  selectedMenu: [],
  propertyInbox: [],
  filteredPropertyInbox: [], // New state property
};


const updateInitialFrequencyData = (state, action) => {
  // Create a new object with the updated property
  const updatedRow = { 
    ...action.row,
    SubmitFrequency: action.value 
  };
  
  // Properly push to the array using Immer
  state.value.push(updatedRow);
};

const updateFrequencyData = (state, action) => {
  const existingDataIndex = state.value.findIndex(
    (data) => data.MappingFileId === action.row.MappingFileId
  );

  if (existingDataIndex !== -1) {
    // Create a new object for the updated item
    state.value[existingDataIndex] = {
      ...state.value[existingDataIndex],
      SubmitFrequency: action.value
    };
  } else {
    // Create a new object with the updated property
    const updatedRow = {
      ...action.row,
      SubmitFrequency: action.value
    };
    state.value.push(updatedRow);
  }
};

const updateInitialTimelineData = (state, action) => {
  // Create a new object with the updated property
  const updatedRow = {
    ...action.row,
    SubmitTimelineDay: action.value
  };
  
  // Properly push to the array
  state.value.push(updatedRow);
};

const updateTimelineData = (state, action) => {
  const existingDataIndex = state.value.findIndex(
    (data) => data.MappingFileId === action.row.MappingFileId
  );

  if (existingDataIndex !== -1) {
    // Create a new object for the updated item
    state.value[existingDataIndex] = {
      ...state.value[existingDataIndex],
      SubmitTimelineDay: action.value
    };
  } else {
    // Create a new object with the updated property
    const updatedRow = {
      ...action.row,
      SubmitTimelineDay: action.value
    };
    state.value.push(updatedRow);
  }
};

export const frequencyEditRowSlice = createSlice({
  name: "frequecy-row-edit",
  initialState,
  reducers: {
    editfrequency: (state, action) => {
      state.value.length === 0
        ? updateInitialFrequencyData(state, action.payload)
        : updateFrequencyData(state, action.payload);
    },
    editTimline: (state, action) => {
     // console.log(state.value)
      state.value.length === 0
        ? updateInitialTimelineData(state, action.payload)
        : updateTimelineData(state, action.payload);
    },
    addSelectedMenu: (state, action) => {
      state.selectedMenu = action.payload;
    },
    setInitialPropertyInbox: (state, action) => {
      state.propertyInbox = action.payload;
    },
    setFilteredPropertyInbox: (state, action) => {
      state.filteredPropertyInbox = action.payload;
    },
  },
});

export const { editfrequency, editTimline, addSelectedMenu, setInitialPropertyInbox ,setFilteredPropertyInbox} =
  frequencyEditRowSlice.actions;

export default frequencyEditRowSlice.reducer;
